import { Box, Dialog, DialogContent, DialogTitle, Drawer, Grid, IconButton, SwipeableDrawer, Typography } from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import TrackBody from "./TrackBody";
import TrackTitle, { TrackArchiveTitle } from "./TrackTitle";
import { makeStyles } from "@material-ui/core";
import SideBar from "../../components/SideBar";
import StartTrackingModal from "./startTrackingModal";
import AddTrackingPopUp from "../testAddGolas/AddTrackingPopUp/AddTrackingPopUp";
import { UserTypeContext } from "../../context/userStatus";
import { userService } from "../../services/auth";
import FullpageLoader from "../../components/fullPageLoader";
import PersonalTrackBody from "./PersonalTrackBody";
import AddCategoryModal from "./AddCategoryModal";
import moment from "moment";
import { trackingService } from "../../services/tracking";
import { addCategoryJourneyAction, addInfluenceAction, addNotesJourneyAction, addOutcomeAction, addRefelectiveAction, isExpandMode } from "../../store/actions/userTypeAction";
import ArchiveItemTable from "./ArchiveItemTable";
import ModalCloseIconBlack from "../../assets/images/icon/modalCloseIconBlack";
import LeftSideOutCome from "../outcome/leftOutcome";
import RightSideOutcomeTracking from "./rightSideOutcomeTracking";
import palette from "../../theme/palette";
import { OutcomeStatus } from "../../utils/staticDataJson";
import LeftSideInfluence from "../influence/leftSideInfluence";
import RightSideInfluenceTracking from "./rightSideInfluenceTracking";
import LeftSideReflectiveQue from "../reflective-questions/leftSideRefQue";
import RightSideRefQuesTracking from "./rightSideRefQuesTracking";
import TrackerScreenMobile from "./TrackerScreenMobile";
import useWidth from "../../utils/useWidth";
import SnackBarComp from "../../components/snackBar";
import ShareSocialReportModal from "./Modals/ShareSocialReportModal";
import { contactsService } from "../../services/contactsService";
import { ContactsContext } from "../../context/userIContacts";
import { setAllContacts, setGroupContacts, setShareModalOpen } from "../../store/actions/contactsActions";
import TrackHeader from "./TrackHeader";
import GetIdeasIcon from "../../assets/images/icon/getIdeas";
import LeftSideOutComeNew from "../outcome/leftOutcomeNew";
import RightSideOutcomeTrackingNew from "./rightSideOutcomeTrackingNew";
import LeftSideInfluenceNew from "../influence/leftSideInfluenceNew";
import MultiDrawerAddEditComponent, { MultiDrawerAddEditComponentMobile } from "../../components/MultiDrawerComponent";
import { influenceService } from "../../services/influence";
import { InfluenceGetResponse } from "../../interfaces/outcomeModal";
import LeftSideReflectiveQueNew from "../reflective-questions/leftSideRefQueNew";
import { useLocation } from "react-router-dom";
import LimitReachedPopup from "./limitReachedModal";
import TrackingViewNew from "../trackerNew";
import { outcomeService } from "../../services/outcome";
import { reflectiveQueService } from "../../services/reflective-questions";
import BackIcon from "../../assets/images/icon/BackIcon";
import { pxToRem } from "../../theme/typography";
import MobileScreen from "../trackingMobilev2/mobileScreen";
import DesktopView from "../trackerNewV2/desktopView";
import CommonTypo from "../../components/CommonTypo";
import TabBox from "../../components/TabBox";

const useStyles = makeStyles((theme) => ({
  trackBodyGrid: {
    display: "flex",
    backgroundColor: "white",
    zIndex: 1,
    flexShrink: 0,
    height: '100vh',
    overflow: 'auto'
  },
  modalCloseIcon: {
    position: "absolute",
    right: 0,
    top: 0,
    cursor: "pointer",
    zIndex: 1,
  },
  modalCloseIconMobile: {
    // position: "fixed",
    right: 0,
    left: 0,
    top: 0,
    cursor: "pointer",
    zIndex: 1,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column-reverse"
  },
  drawerTitle: {
    display: 'flex',
    padding: '20px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    alignSelf: 'stretch',
    borderBottom: '1px solid #F3F3F3',
    background: "#FFF",
  },
  drawerTitleMobile: {
    display: 'flex',
    padding: '12px 0px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
    alignSelf: 'stretch',
    background: "#FFF",
  },
  drawerBody: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: "column"

  },
  headerTitle: {
    display: 'flex',
    padding: '24px 32px',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderBottom: '1px solid #F3F3F3',
    background: '#FFF',
    justifyContent: "space-between"

  }
}));

const TrackingView = () => {
  const classes = useStyles();
  const { state: IUserTypeState, dispatch: userTypeDispatch } =
    useContext(UserTypeContext);
  // const [isExpandMode, setIsExpandMode] = useState(false);
  const [isExpandable, setIsExpandable] = useState(localStorage.getItem("isExpandMode") === "true");
  // const [ispersonalMode, setIsPersonalMode] = useState(false);

  const { state: IContactTypeState, dispatch: contactsDispatch } =
    useContext(ContactsContext);

  const [openStartTracking, setOpenStartTracking] = useState(
    IUserTypeState?.isNewUser
  );
  const [createDate, setCreateDate] = useState<any>();
  const [showLoader, setShowLoader] = useState(true);
  let userValues = JSON.parse(localStorage.getItem("userValues"));
  const [open, setOpen] = useState(false);
  const [isArchiveMode, setIsArchiveMode] = useState(false);
  const [mobileStartDay, setMobileStartDay] = useState();
  const [mobileEndDay, setMobileEndDay] = useState();
  let location = useLocation();
  const [showOutcome, setShowOutcome] = useState<boolean>(false);
  const [showInfluence, setShowInfluence] = useState<boolean>(false);
  const [showQues, setShowQues] = useState<boolean>(false);
  const [openStartModal, setStartModal] = useState(false);
  const [openStartModalInfluence, setStartModalInfluence] = useState(false);
  const [openStartModalQues, setStartModalQues] = useState(false);
  const [addOutcomeTracking, setAddOutcomeTracking] = useState(false);
  const [addInfluenceTracking, setAddInfluenceTracking] = useState(false);
  const [transformToInfluenceTracking, setTransformToInfluenceTracking] = useState(false)
  const [transformToOutcomeTracking, setTransformToOutcomeTracking] = useState(false)
  const [transformInInfluenceTracking, setTransformInInfluenceTracking] = useState(false)
  const [addQuesTracking, setAddQuesTracking] = useState(false);
  const [selectedIn, setSelectedIn] = useState("Outcome");

  const [showSnakbar, setShowSnakbar] = useState(false);
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [limitPopupVisible, setLimitReachPopupVisible] = useState<boolean>(false);
  const [limitPopuptype, setLimitReachPopuptype] = useState<'outcome' | 'influence' | 'question'>();
  const handleShareModalOpen = (val) => {
    contactsDispatch(setShareModalOpen(val))
  }
  useEffect(() => {
    setIsArchiveMode((location.state as any)?.direct || false)
  }, [(location.state as any)?.direct])
  const [outComeValue, setOutcomeValue] = useState<any>("");
  const [textInput, setTextInput] = useState(OutcomeStatus);
  const [influenceData, setInfluenceData] = useState<any>();
  const [questionData, setQuestionData] = useState<any>();
  const [outcomeIdeas, setOutcomeIdeas] = useState();
  const [influenceIdeas, setInfluenceIdeas] = useState();
  const [reflectiveIdeas, setReflectiveIdeas] = useState();
  const [weekday, setWeekDay] = useState(new Map());
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [needIdeasOpen, setNeedIdeasOpen] = useState(false)
  const [openRightSideSuggestion, setOpenRightSideSuggestion] = useState(false)
  const width = useWidth()
  const [categoryId, setCategoryId] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getUserDetails();
    getAllContacts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    // IUserTypeState?.isPersonal && getPersonalData()
    setShowLoader(true);
  }, [IUserTypeState?.isPersonal])
  const getAllContacts = () => {
    contactsService
      .getContactsList(IUserTypeState.token)
      .then((data: any) => {
        const { allContact = [], groupData = [] } = data;
        contactsDispatch(setAllContacts(allContact))
        contactsDispatch(setGroupContacts(groupData.map(it => {
          if (it.contacts && it.contacts.length) {
            it.contacts = it.contacts.map(ite => ({
              ...ite,
              parent: it._id
            }))
          }

          return it
        })))
      })
      .catch((error) => {
        console.log("User profile Error");
      });
  }
  const getUserDetails = () => {
    const userId = {
      uid: IUserTypeState?.userId ? IUserTypeState?.userId : userValues?.uid,
    };
    userService
      .getUserById(userId)
      .then((data: any) => {
        setCreateDate(data?.data?.createdAt);
        localStorage.setItem("userValues", JSON.stringify(data?.data));
        setShowLoader(false);
      })
      .catch((error) => {
        console.log("User profile Error");
      });
  };

  const getPersonalData = async () => {
    setShowLoader(true);
    let data
    const startDay = moment().clone().subtract(10, "day");
    const endDay = moment().clone().add(15, "day");

    const bodyData = {
      from: moment(startDay).format("MM-DD-YYYY"),
      to: moment(endDay).format("MM-DD-YYYY"),
    };

    data = await trackingService.getPersonalJourneyList(
      IUserTypeState.token,
      bodyData
    );
    userTypeDispatch(addCategoryJourneyAction(data?.data));
    if (
      !data?.data?.length ||
      (data?.data?.length === 1 &&
        data?.data[0]?.name?.toUpperCase() === "OTHER")
    ) {
      handleClickOpen();
    }
  }
  const getInfluenceList = async () => {
    if (IUserTypeState.isPersonal) {
      const bodyData = {
        from: moment(mobileStartDay).format("MM-DD-YYYY"),
        to: moment(mobileEndDay).format("MM-DD-YYYY"),
      };
      let data = await trackingService.getPersonalJourneyList(
        IUserTypeState.token,
        bodyData
      );
      userTypeDispatch(addCategoryJourneyAction(data?.data));
      userTypeDispatch(addNotesJourneyAction(data?.data));
    }
    influenceService
      .getInfluenceList(IUserTypeState.token)
      .then((data: InfluenceGetResponse) => {
        userTypeDispatch(addInfluenceAction(data?.data));
      })
      .catch((error) => {
        console.log('influence Error');
      });
  };
  const handleCloseStartModal = () => {
    setSelectedIn("Outcome");
    setOutcomeValue("");
    setTextInput(OutcomeStatus);
    setAddOutcomeTracking(false);
    setInfluenceData("");
    setAddInfluenceTracking(false);
    setQuestionData("");
    setWeekDay(new Map());
    setAddQuesTracking(false);
  };

  const handleCloseStartModalInfluence = () => {
    setInfluenceData("");
    setTextInput(OutcomeStatus);
    setAddInfluenceTracking(false);
  };

  const handleCloseStartModalQues = () => {
    setQuestionData("");
    setWeekDay(new Map());
    setAddQuesTracking(false);
  };

  const handleCloseSnakbar = () => {
    setShowSnakbar(false);
  };
  const isMobile = width <= 768
  console.log("addOutcomeTracking", addOutcomeTracking);
  console.log("addOutcomeTracking selectedIn", selectedIn);

  return (
    <>
      {showLoader && <FullpageLoader />}
      <SnackBarComp
        showSnakbar={showSnakbar}
        handleCloseSnakbar={handleCloseSnakbar}
        snakbarMsg={snakbarMsg}
        type={msgType ? msgType : "success"}
      />
      {width > 768 ? (
        <DesktopView />
        // <TrackingViewNew />
      ) : (
        // <TrackerScreenMobile
        <MobileScreen
          createDate={createDate}
          setCreateDate={setCreateDate}
          setAddOutcomeTracking={setAddOutcomeTracking}
          setStartModal={setStartModal}
          setStartModalInfluence={/* setStartModalInfluence */setStartModal}
          setStartModalQues={/* setStartModalQues */setStartModal}
          setAddInfluenceTracking={/* setAddInfluenceTracking */() => {
            console.log("setAddInfluenceTracking");

            setSelectedIn("Influence")
            setAddOutcomeTracking(true)
          }}
          setAddQuesTracking={/* setAddQuesTracking */() => {
            setSelectedIn("Question")
            setAddOutcomeTracking(true)
          }}
          setOutcomeIdeas={setOutcomeIdeas}
          setInfluenceIdeas={setInfluenceIdeas}
          setReflectiveIdeas={setReflectiveIdeas}
          setShowLoader={setShowLoader}
          setOutcomeValue={setOutcomeValue}
          setInfluenceData={setInfluenceData}
          setQuestionData={setQuestionData}
          setMobileEndDay={setMobileEndDay}
          setMobileStartDay={setMobileStartDay}
          setLimitReachPopupVisible={setLimitReachPopupVisible}
          setLimitReachPopuptype={setLimitReachPopuptype}
        />
      )}
      {/* ADD OUTCOME MODAL */}
      {addOutcomeTracking && /* width <= 768 */false && (
        <Dialog
          fullScreen
          disableEscapeKeyDown
          onClose={handleCloseStartModal}
          open={openStartModal}
          className="dialogWrapper dialogWrapper-outcome"
        >
          <DialogTitle className={classes.modalCloseIcon}>
            <span
              onClick={handleCloseStartModal}
            >
              <ModalCloseIconBlack />
            </span>
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              columns={16}
              sx={{ backgroundColor: palette.secondary.light }}
            >
              <Grid
                sx={{ backgroundColor: palette.common.white }}
                item
                xs={9.63}
                className="leftside-menu login-screen outcome-screen outcome-left-layout"
              >
                {/* OUTCOME LEFT SECTION */}
                <LeftSideOutCome
                  outComeValue={outComeValue}
                  setOutcomeValue={setOutcomeValue}
                  outcomeIdeas={outcomeIdeas}
                  setShowOutcome={setShowOutcome}
                  showOutcome={true}
                  setAddOutcomeTracking={setAddOutcomeTracking}
                  setTextInput={setTextInput}
                  setShowSnakbar={setShowSnakbar}
                  setMsgType={setMsgType}
                  setSnakbarMsg={setSnakbarMsg}
                  textInput={textInput}
                  categoryId={categoryId}
                  setTransformToInfluenceTracking={setTransformToInfluenceTracking}
                  width={width}
                  startDate={startDate}
                  endDate={endDate}
                />
              </Grid>
              {
                width > 768 &&
                <Grid
                  item
                  xs={6.37}
                  className="rightside-menu outcome-menu outcome-right-layout"
                  sx={{ backgroundColor: palette.common.bgColor }}
                >
                  {/* OUTCOME SUGGESTION LIST */}
                  <RightSideOutcomeTracking
                    outcomeIdeas={outcomeIdeas}
                    setOutcomeValue={setOutcomeValue}
                  />
                </Grid>
              }
            </Grid>
          </DialogContent>
        </Dialog>
      )}
      {addOutcomeTracking && width <= 768 && (
        <AddTrackingViewmobile
          classes={classes}
          open={openStartModal}
          handleClose={handleCloseStartModal}
          selectedIn={selectedIn} setSelectedIn={setSelectedIn}
          restComponent={
            selectedIn === "Outcome" ?
              <LeftSideOutComeNew
                outComeValue={outComeValue}
                setOutcomeValue={setOutcomeValue}
                outcomeIdeas={outcomeIdeas}
                setShowOutcome={setShowOutcome}
                showOutcome={true}
                setAddOutcomeTracking={setAddOutcomeTracking}
                setTextInput={setTextInput}
                setShowSnakbar={setShowSnakbar}
                setMsgType={setMsgType}
                setSnakbarMsg={setSnakbarMsg}
                textInput={textInput}
                categoryId={categoryId}
                setTransformToInfluenceTracking={setTransformToInfluenceTracking}
                width={width}
                startDate={startDate}
                endDate={endDate}
                handleCloseStartModal={handleCloseStartModal}
                setNeedIdeasOpen={setNeedIdeasOpen}
                setLimitReachPopupVisible={setLimitReachPopupVisible}
                setLimitReachPopuptype={setLimitReachPopuptype}
                isMobile={isMobile}
                getOutcomeList={async () => {
                  if (IUserTypeState.isPersonal) {
                    const bodyData = {
                      from: moment(mobileStartDay).format("MM-DD-YYYY"),
                      to: moment(mobileEndDay).format("MM-DD-YYYY"),
                    };
                    let data = await trackingService.getPersonalJourneyList(
                      IUserTypeState.token,
                      bodyData
                    );
                    userTypeDispatch(addCategoryJourneyAction(data?.data));
                    userTypeDispatch(addNotesJourneyAction(data?.data));
                  }
                  outcomeService
                    .getOutcomeList(IUserTypeState.token)
                    .then((data: any) => {
                      userTypeDispatch(addOutcomeAction(data?.data));
                    })
                    .catch((error) => {
                      console.log("Outcome Error");
                    });
                }}
              /> : selectedIn === "Influence" ?
                <LeftSideInfluenceNew
                  setInfluenceData={setInfluenceData}
                  influenceData={influenceData}
                  influenceIdeas={influenceIdeas}
                  setShowSnakbar={setShowSnakbar}
                  setMsgType={setMsgType}
                  setSnakbarMsg={setSnakbarMsg}
                  showInfluence={true}
                  setAddInfluenceTracking={/* setAddInfluenceTracking */() => {
                    setSelectedIn("Outcome")
                    setAddOutcomeTracking(false)
                  }}
                  setShowInfluence={setShowInfluence}
                  setTextInput={setTextInput}
                  textInput={textInput}
                  handleCloseStartModal={/* handleCloseStartModalInfluence */handleCloseStartModal}
                  getInfluenceList={getInfluenceList}
                  setInfluenceIdeas={setInfluenceIdeas}
                  // transformToOutcomeTracking={props?.transformToOutcomeTracking}
                  // transformInInfluenceTracking={
                  //   props?.transformInInfluenceTracking
                  // }
                  // setTransformInInfluenceTracking={
                  //   props?.setTransformInInfluenceTracking
                  // }
                  // startDate={props.startDate}
                  // endDate={props.endDate}
                  setNeedIdeasOpen={setNeedIdeasOpen}
                  setLimitReachPopupVisible={setLimitReachPopupVisible}
                  setLimitReachPopuptype={setLimitReachPopuptype}
                  isMobile={isMobile}
                /> : selectedIn === "Question" ?
                  <LeftSideReflectiveQueNew
                    questionData={questionData}
                    setQuestionData={setQuestionData}
                    reflectiveIdeas={reflectiveIdeas}
                    showRefQues={true}
                    setAddQuesTracking={/* setAddQuesTracking */() => {
                      setSelectedIn("Outcome")
                      setAddOutcomeTracking(false)
                    }}
                    setShowQues={setShowQues}
                    setWeekDay={setWeekDay}
                    weekday={weekday}
                    categoryId={categoryId}
                    width={width}
                    setShowSnakbar={setShowSnakbar}
                    setMsgType={setMsgType}
                    handleCloseStartModalQues={/* handleCloseStartModalQues */handleCloseStartModal}
                    setSnakbarMsg={setSnakbarMsg}
                    startDate={startDate}
                    endDate={endDate}
                    setNeedIdeasOpen={setNeedIdeasOpen}
                    setLimitReachPopupVisible={setLimitReachPopupVisible}
                    setLimitReachPopuptype={setLimitReachPopuptype}
                    isMobile={isMobile}
                    getReflectiveList={async () => {
                      if (IUserTypeState.isPersonal) {
                        const bodyData = {
                          from: moment(mobileStartDay).format("MM-DD-YYYY"),
                          to: moment(mobileEndDay).format("MM-DD-YYYY"),
                        };
                        let data = await trackingService.getPersonalJourneyList(
                          IUserTypeState.token,
                          bodyData
                        );
                        userTypeDispatch(addCategoryJourneyAction(data?.data));
                        userTypeDispatch(addNotesJourneyAction(data?.data));
                      }
                      reflectiveQueService
                        .getReflectiveList(IUserTypeState.token)
                        .then((data) => {
                          userTypeDispatch(addRefelectiveAction(data?.data));
                        })
                        .catch((error) => {
                          console.log('Ques error');
                        });
                    }}
                  />
                  : null
          }
          isEdit={((selectedIn === "Outcome" && outComeValue?._id) || (selectedIn === "Influence" && influenceData?.uid) || (selectedIn === "Question" && questionData?.uid))}
          title={<>{((selectedIn === "Outcome" && outComeValue?._id) || (selectedIn === "Influence" && influenceData?.uid) || (selectedIn === "Question" && questionData?.uid)) ? "Edit metric" : "Add metric"}</>}
        />
      )}
      {
        addOutcomeTracking && width > 768 && (
          <Drawer
            anchor="right"
            sx={{
              "& .MuiPaper-root": {
                width: isMobile ? "100%" : needIdeasOpen ? "80%" : '70%'
              }
            }}
            open={openStartModal}
            onClose={handleCloseStartModal}
          >
            <div className={classes.drawerTitle}>
              <Typography sx={isMobile ? {
                color: palette.common.black,
                fontSize: "16px!important",
                fontWeight: 500,
                width: "80%",
                textAlign: "center"
              } : {
                color: palette.common.black,
                fontSize: "16px!important",
                fontWeight: 500
              }}>{outComeValue?._id ? "Edit" : "Add new metric to"} <span style={{ color: palette.primary.main }}>Outcomes</span></Typography>
            </div>

            <DialogTitle className={classes.modalCloseIcon}>
              <span
                onClick={handleCloseStartModal}
              >
                <ModalCloseIconBlack />
              </span>
            </DialogTitle>
            <DialogContent sx={{
              padding: 0,
              overflowX: "hidden"

            }} className={isMobile ? "hide-scrollbar" : ""}>

              {/* OUTCOME LEFT SECTION */}
              <LeftSideOutComeNew
                outComeValue={outComeValue}
                setOutcomeValue={setOutcomeValue}
                outcomeIdeas={outcomeIdeas}
                setShowOutcome={setShowOutcome}
                showOutcome={true}
                setAddOutcomeTracking={setAddOutcomeTracking}
                setTextInput={setTextInput}
                setShowSnakbar={setShowSnakbar}
                setMsgType={setMsgType}
                setSnakbarMsg={setSnakbarMsg}
                textInput={textInput}
                categoryId={categoryId}
                setTransformToInfluenceTracking={setTransformToInfluenceTracking}
                width={width}
                startDate={startDate}
                endDate={endDate}
                handleCloseStartModal={handleCloseStartModal}
                setNeedIdeasOpen={setNeedIdeasOpen}
                setLimitReachPopupVisible={setLimitReachPopupVisible}
                setLimitReachPopuptype={setLimitReachPopuptype}
                isMobile={isMobile}
                getOutcomeList={async () => {
                  if (IUserTypeState.isPersonal) {
                    const bodyData = {
                      from: moment(mobileStartDay).format("MM-DD-YYYY"),
                      to: moment(mobileEndDay).format("MM-DD-YYYY"),
                    };
                    let data = await trackingService.getPersonalJourneyList(
                      IUserTypeState.token,
                      bodyData
                    );
                    userTypeDispatch(addCategoryJourneyAction(data?.data));
                    userTypeDispatch(addNotesJourneyAction(data?.data));
                  }
                  outcomeService
                    .getOutcomeList(IUserTypeState.token)
                    .then((data: any) => {
                      userTypeDispatch(addOutcomeAction(data?.data));
                    })
                    .catch((error) => {
                      console.log("Outcome Error");
                    });
                }}
              />
            </DialogContent>

          </Drawer>
        )
      }

      {/* ADD INFLUENCE MODAL */}
      {
        addInfluenceTracking && width > 768 && (
          <MultiDrawerAddEditComponent
            handleClose={handleCloseStartModalInfluence}
            drawerTitle={<>{influenceData?.uid ? "Edit" : "Add new metric to"} <span style={{ color: palette.primary.main }}>Influences</span></>}
            secondOpen={needIdeasOpen}
            isMobile={isMobile}
          >
            <LeftSideInfluenceNew
              setInfluenceData={setInfluenceData}
              influenceData={influenceData}
              influenceIdeas={influenceIdeas}
              setShowSnakbar={setShowSnakbar}
              setMsgType={setMsgType}
              setSnakbarMsg={setSnakbarMsg}
              showInfluence={true}
              setAddInfluenceTracking={setAddInfluenceTracking}
              setShowInfluence={setShowInfluence}
              setTextInput={setTextInput}
              textInput={textInput}
              handleCloseStartModal={handleCloseStartModalInfluence}
              getInfluenceList={getInfluenceList}
              setInfluenceIdeas={setInfluenceIdeas}
              // transformToOutcomeTracking={props?.transformToOutcomeTracking}
              // transformInInfluenceTracking={
              //   props?.transformInInfluenceTracking
              // }
              // setTransformInInfluenceTracking={
              //   props?.setTransformInInfluenceTracking
              // }
              // startDate={props.startDate}
              // endDate={props.endDate}
              setNeedIdeasOpen={setNeedIdeasOpen}
              setLimitReachPopupVisible={setLimitReachPopupVisible}
              setLimitReachPopuptype={setLimitReachPopuptype}
              isMobile={isMobile}
            />
          </MultiDrawerAddEditComponent>
        )
      }
      {
        addInfluenceTracking && width <= 768 && (
          <MultiDrawerAddEditComponentMobile
            handleClose={handleCloseStartModalInfluence}
            drawerTitle={<>{influenceData?.uid ? "Edit " : "Add a new "} influence</>}
            secondOpen={needIdeasOpen}
            isMobile={isMobile}
          >
            <LeftSideInfluenceNew
              setInfluenceData={setInfluenceData}
              influenceData={influenceData}
              influenceIdeas={influenceIdeas}
              setShowSnakbar={setShowSnakbar}
              setMsgType={setMsgType}
              setSnakbarMsg={setSnakbarMsg}
              showInfluence={true}
              setAddInfluenceTracking={setAddInfluenceTracking}
              setShowInfluence={setShowInfluence}
              setTextInput={setTextInput}
              textInput={textInput}
              handleCloseStartModal={handleCloseStartModalInfluence}
              getInfluenceList={getInfluenceList}
              setInfluenceIdeas={setInfluenceIdeas}
              // transformToOutcomeTracking={props?.transformToOutcomeTracking}
              // transformInInfluenceTracking={
              //   props?.transformInInfluenceTracking
              // }
              // setTransformInInfluenceTracking={
              //   props?.setTransformInInfluenceTracking
              // }
              // startDate={props.startDate}
              // endDate={props.endDate}
              setNeedIdeasOpen={setNeedIdeasOpen}
              setLimitReachPopupVisible={setLimitReachPopupVisible}
              setLimitReachPopuptype={setLimitReachPopuptype}
              isMobile={isMobile}
            />
          </MultiDrawerAddEditComponentMobile>
        )
      }

      {/* ADD REFLECTIVE QUESTION MODAL */}
      {
        addQuesTracking && width > 768 && (
          <MultiDrawerAddEditComponent
            handleClose={handleCloseStartModalQues}
            drawerTitle={<>{questionData?.uid ? "Edit" : "Add new metric to"} <span style={{ color: palette.primary.main }}>Qualitative Reflection</span></>}
            secondOpen={needIdeasOpen}
            isMobile={isMobile}
          >
            <LeftSideReflectiveQueNew
              questionData={questionData}
              setQuestionData={setQuestionData}
              reflectiveIdeas={reflectiveIdeas}
              showRefQues={true}
              setAddQuesTracking={setAddQuesTracking}
              setShowQues={setShowQues}
              setWeekDay={setWeekDay}
              weekday={weekday}
              categoryId={categoryId}
              width={width}
              setShowSnakbar={setShowSnakbar}
              setMsgType={setMsgType}
              handleCloseStartModalQues={handleCloseStartModalQues}
              setSnakbarMsg={setSnakbarMsg}
              startDate={startDate}
              endDate={endDate}
              setNeedIdeasOpen={setNeedIdeasOpen}
              setLimitReachPopupVisible={setLimitReachPopupVisible}
              setLimitReachPopuptype={setLimitReachPopuptype}
              isMobile={isMobile}
              getReflectiveList={async () => {
                if (IUserTypeState.isPersonal) {
                  const bodyData = {
                    from: moment(mobileStartDay).format("MM-DD-YYYY"),
                    to: moment(mobileEndDay).format("MM-DD-YYYY"),
                  };
                  let data = await trackingService.getPersonalJourneyList(
                    IUserTypeState.token,
                    bodyData
                  );
                  userTypeDispatch(addCategoryJourneyAction(data?.data));
                  userTypeDispatch(addNotesJourneyAction(data?.data));
                }
                reflectiveQueService
                  .getReflectiveList(IUserTypeState.token)
                  .then((data) => {
                    userTypeDispatch(addRefelectiveAction(data?.data));
                  })
                  .catch((error) => {
                    console.log('Ques error');
                  });
              }}
            />
          </MultiDrawerAddEditComponent>
          // <Dialog
          //   fullScreen
          //   disableEscapeKeyDown
          //   onClose={handleCloseStartModalQues}
          //   open={openStartModalQues}
          //   className="dialogWrapper dialogWrapper-outcome"
          // >
          //   <DialogTitle className={classes.modalCloseIcon}>
          //     <span
          //       onClick={handleCloseStartModalQues}
          //     >
          //       <ModalCloseIconBlack />
          //     </span>
          //   </DialogTitle>
          //   <DialogContent>
          //     <Grid
          //       container
          //       columns={16}
          //       sx={{ backgroundColor: palette.secondary.light }}
          //     >
          //       <Grid
          //         sx={{ backgroundColor: palette.common.white }}
          //         item
          //         xs={9.63}
          //         className="leftside-menu login-screen outcome-screen outcome-left-layout"
          //       >
          //         {/* REFLECTIVE QUESTION SECTION */}
          //         <LeftSideReflectiveQue
          //           questionData={questionData}
          //           setQuestionData={setQuestionData}
          //           reflectiveIdeas={reflectiveIdeas}
          //           showRefQues={true}
          //           setAddQuesTracking={setAddQuesTracking}
          //           setShowQues={setShowQues}
          //           setWeekDay={setWeekDay}
          //           weekday={weekday}
          //           categoryId={categoryId}
          //           width={width}
          //           setShowSnakbar={setShowSnakbar}
          //           setMsgType={setMsgType}
          //           setSnakbarMsg={setSnakbarMsg}
          //           startDate={startDate}
          //           endDate={endDate}
          //         />
          //       </Grid>
          //       {width > 768 && <Grid
          //         item
          //         xs={6.37}
          //         className="rightside-menu outcome-menu outcome-right-layout"
          //         sx={{ backgroundColor: palette.common.bgColor }}
          //       >
          //         {/* REFLECTIVE QUESTION SUGGSESTION LIST */}
          //         <RightSideRefQuesTracking
          //           reflectiveIdeas={reflectiveIdeas}
          //           setQuestionData={setQuestionData}
          //         />
          //       </Grid>}
          //     </Grid>
          //   </DialogContent>
          // </Dialog>
        )
      }
      {
        addQuesTracking && width <= 768 && (
          <MultiDrawerAddEditComponentMobile
            handleClose={handleCloseStartModalQues}
            drawerTitle={<>{questionData?.uid ? "Edit" : "Add a new "} <>reflective question</></>}
            secondOpen={needIdeasOpen}
            isMobile={isMobile}
          >
            <LeftSideReflectiveQueNew
              questionData={questionData}
              setQuestionData={setQuestionData}
              reflectiveIdeas={reflectiveIdeas}
              showRefQues={true}
              setAddQuesTracking={setAddQuesTracking}
              setShowQues={setShowQues}
              setWeekDay={setWeekDay}
              weekday={weekday}
              categoryId={categoryId}
              width={width}
              setShowSnakbar={setShowSnakbar}
              setMsgType={setMsgType}
              handleCloseStartModalQues={handleCloseStartModalQues}
              setSnakbarMsg={setSnakbarMsg}
              startDate={startDate}
              endDate={endDate}
              setNeedIdeasOpen={setNeedIdeasOpen}
              setLimitReachPopupVisible={setLimitReachPopupVisible}
              setLimitReachPopuptype={setLimitReachPopuptype}
              isMobile={isMobile}
              getReflectiveList={async () => {
                if (IUserTypeState.isPersonal) {
                  const bodyData = {
                    from: moment(mobileStartDay).format("MM-DD-YYYY"),
                    to: moment(mobileEndDay).format("MM-DD-YYYY"),
                  };
                  let data = await trackingService.getPersonalJourneyList(
                    IUserTypeState.token,
                    bodyData
                  );
                  userTypeDispatch(addCategoryJourneyAction(data?.data));
                  userTypeDispatch(addNotesJourneyAction(data?.data));
                }
                reflectiveQueService
                  .getReflectiveList(IUserTypeState.token)
                  .then((data) => {
                    userTypeDispatch(addRefelectiveAction(data?.data));
                  })
                  .catch((error) => {
                    console.log('Ques error');
                  });
              }}
            />
          </MultiDrawerAddEditComponentMobile>
        )
      }
      <LimitReachedPopup open={limitPopupVisible} setopenOutcomeclosePopup={setLimitReachPopupVisible}
        handleCloseStartModal={handleCloseStartModal}
        handleCloseStartModalInfluence={handleCloseStartModalInfluence}
        handleCloseStartModalQues={handleCloseStartModalQues}
        type={limitPopuptype} />
      {/* {shareModalOpen && (
        <ShareSocialReportModal
          shareModalOpen={shareModalOpen}
          handleShareModalOpen={handleShareModalOpen}
          getAllContacts={getAllContacts}
        />

      )} */}
    </>
  );
};

export default TrackingView;


const AddTrackingViewmobile = ({ title, open, handleClose, isEdit = false, classes, selectedIn, setSelectedIn, restComponent }) => {
  console.log("selectedIn", selectedIn);

  return <Dialog
    sx={{
      "& .MuiPaper-root": {
        "@media  (max-width: 768px)": {
          padding: "16px 24px 32px",
          gap: "16px",
          borderRadius: "12px 12px 0px 0px !important",
          display: "flex",
          flexDirection: "column",
          height: "max-content",
          // minHeight: selectedIn === "Question" ? "max-content" : "max-content",
          maxHeight: "calc(100vh - 5%)",
        },
      }
    }}
    className={`dialogWrapper-mobileScreen`}
    open={open}
    onClose={handleClose}
  >
    <IconButton
      sx={{ alignSelf: "flex-end", padding: 0 }}
      // onClick={handleCloseStartModal}
      onClick={handleClose}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15 15L10 10M10 10L5 5M10 10L15 5M10 10L5 15"
          stroke="black"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconButton>
    <CommonTypo fontWeight={700} size={24} lineHeight={28.8} color="var(--color-text-primary)">{title}</CommonTypo>
    {!isEdit && (
      <Box display={"flex"} flexDirection={"column"} gap={"8px"} alignSelf={"stretch"}>
        <CommonTypo fontWeight={600} size={18} lineHeight={21.6} color="var(--color-text-primary)">{"Metric type"}</CommonTypo>
        <TabBox tabs={[
          {
            name: "Outcome"
          },
          {
            name: "Influence"
          },
          {
            name: "Question"
          }
        ]} isMobile onSelectTab={(it) => {
          if (!isEdit) {
            setSelectedIn(it.name)
          }
          // setActiveTrackerType(it.name === "Personal structure" ? "personal" : "Default")
          // userTypeDispatch(isPersonalMode(it.name === "Personal structure" ? true : false))
          // localStorage.setItem("mode", it.name === "Personal structure" ? "personal" : "Default")
        }} activeTab={selectedIn} fullWidth />
      </Box>
    )}

    {/* <DialogTitle className={classes.modalCloseIconMobile}>
      <div className={classes.drawerTitleMobile}>
        <Typography sx={{
          color: palette.common.black,
          fontSize: `${pxToRem(24)} !important`,
          fontWeight: 600,
          width: "80%",
          "&.MuiTypography-root": {
            "@media  (max-width: 600px) and (min-width: 100px)": {
              fontSize: `${pxToRem(24)} !important`,
              lineHeight: "100% !important"
            },
          }
          // textAlign: "center"
        }}>{title}</Typography>
      </div>
      <span
        onClick={handleClose}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 17.59L10.42 12L16 6.41L14.59 5L7.59 12L14.59 19L16 17.59Z" fill="#3E4240" />
        </svg>

      </span>
    </DialogTitle> */}
    {/* <DialogContent sx={{
      padding: 0,
    }} className={"hide-scrollbar"}> */}
    {restComponent}
    {/* </DialogContent> */}

  </Dialog>
}